import { makeAutoObservable } from 'mobx';
import { validateCandleTrigger } from './validateCandleTrigger';

export class CandleTriggerData {
  candlesBack = 1;
  timeUnit = 'DAYS';
  candleDuration = 1;
  checkValidation = true;
  breakBy = 0;
  bounceOnGapFill = false;
  gapType = 'highLow';

  constructor(initialData) {
    makeAutoObservable(this);
    if (initialData) {
      Object.keys(initialData).forEach(
        (field) => (this[field] = initialData[field])
      );
    }
  }

  //common methods
  resetToDefaults = () => {
    this.candlesBack = 1;
    this.timeUnit = 'MINUTES';
    this.candleDuration = 1;
    this.checkValidation = true;
    this.breakBy = 0;
    this.bounceOnGapFill = false;
    this.gapType = 'highLow';
  };
  updateTactic = (dataObj) => {
    for (const key in dataObj) {
      this[key] = dataObj[key];
    }
  };
  validate = (tradePlan) => {
    const data = {
      candlesBack: this.candlesBack,
      timeUnit: this.timeUnit,
      candleDuration: this.candleDuration,
      checkValidation: this.checkValidation,
      breakBy: this.breakBy,
      tradePlan
    };
    const result = validateCandleTrigger(data);
    return result;
  };
  returnJson = () => {
    return {
      candlesBack: this.candlesBack,
      timeUnit: this.timeUnit,
      candleDuration: this.candleDuration,
      checkValidation: this.checkValidation,
      breakBy: this.breakBy,
    };
  };

  //specific methods
  setCandlesBack = (number) => {
    this.candlesBack = number;
  };
  setTimeUnit = (string) => {
    this.timeUnit = string;
  };
  setCandlesDuration = (number) => {
    this.candlesDuration = number;
  };
  setCheckValidation = (bool) => {
    this.checkValidation = bool;
  };
  setBreakBy = (number) => {
    this.breakBy = number;
  };
  setBounceOnGapFill = (bool) => {
    this.bounceOnGapFill = bool;
  };
  setGapType = (string) => {
    this.gapType = string;
  };
}
